"use strict"; // Browserify's process implementation doesn't have hrtime, and this package is small so not much of a burden for
// Node.js users.

var _slicedToArray = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var hrtime = require("browser-process-hrtime");

function toMS(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      sec = _ref2[0],
      nanosec = _ref2[1];

  return sec * 1e3 + nanosec / 1e6;
}

module.exports = {
  hrtime: hrtime,
  toMS: toMS
};